import { render, staticRenderFns } from "./authorized.vue?vue&type=template&id=2a063106&"
import script from "./authorized.vue?vue&type=script&lang=js&"
export * from "./authorized.vue?vue&type=script&lang=js&"
import style0 from "./authorized.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports